import { SVGProps, Ref, forwardRef } from 'react';

export const CameraOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.332 8.734c0-1.333.667-2.666 2.666-2.666 2 0 2.666 1.333 2.666 2.666S9.998 11.4 7.998 11.4s-2.666-1.333-2.666-2.666m1.4 0c0-.459.117-.767.259-.937.104-.124.344-.33 1.007-.33s.903.206 1.007.33c.142.17.26.478.26.937 0 .458-.118.767-.26.937-.104.124-.344.329-1.007.329s-.903-.205-1.007-.33c-.142-.17-.259-.478-.259-.936"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m10.664 1 1.331 1.927c3.466.168 4.001 1.204 4.001 5.667v.712c0 4.982-.667 5.694-5.332 5.694H5.332C.667 15 0 14.288 0 9.306v-.712c0-4.463.535-5.5 4-5.667L5.333 1zm3.932 7.594v.712c0 1.236-.043 2.11-.156 2.748-.111.631-.267.887-.382 1.01-.106.114-.316.263-.869.374-.573.116-1.37.162-2.525.162H5.332c-1.155 0-1.952-.046-2.525-.162-.553-.11-.763-.26-.869-.373-.115-.124-.271-.38-.382-1.01-.113-.64-.156-1.513-.156-2.749v-.712c0-1.102.034-1.922.124-2.546.09-.627.221-.944.336-1.114.155-.228.498-.526 2.208-.608l.692-.034L6.067 2.4H9.93l1.306 1.892.692.034c1.71.082 2.053.38 2.208.608.115.17.247.487.337 1.114.089.624.123 1.444.123 2.546"
                fill="currentColor"
            />
        </g>
    </svg>
));
CameraOutlinedSize16Glyph.displayName = 'CameraOutlinedSize16Glyph';
